// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-05c89017]{display:flex;flex-direction:column;align-items:center;justify-content:center;margin-top:.4375rem;width:100%;background:#592430;height:.625rem;color:#fff;font-size:.08333rem}.footer_link>ul>li[data-v-05c89017]{text-decoration:none;list-style:none;float:left;margin:.05208rem .05208rem}.footer_link>ul>li>a[data-v-05c89017]{color:#fff}", ""]);
// Exports
module.exports = exports;
